import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import NONE_MEMBER from '../../../../../assets/badge_membership_off.png'
import MEMBER from '../../../../../assets/badge_membership_on.png'
import {
  setShowPurchaseCoins,
  setShowMembershipModal
} from '../../../../../redux/designerReducers/designerReducer'
import coinIconImg from '../../../assets/coin.svg'
import { formatMoney } from '../../../utils'
import Actionable from '../Actionable'
import Badges from '../Badges'
import Following from '../Following'
import FollowListModal from '../FollowListModal'
import Info from '../Info'
import { Container } from './ProfileInfo.styles'
import { getMembershipType } from '../../../../../utils/getMembershipType'

import MembershipBanner from '../../../../../components/MembershipBanner'

export const ProfileInfo = ({ isOthers, openCoinsHistory }) => {
  const dispatch = useDispatch()
  const [isFollowsVisible, setIsFollowsVisible] = useState(false)
  const { me } = useSelector(state => state.profile)
  const { others } = useSelector(state => state.profile)

  const handleCoin = () => {
    dispatch(setShowPurchaseCoins(true))
  }

  const handleMembership = () => {
    dispatch(setShowMembershipModal(true))
  }

  const user = isOthers ? others : me

  const membershipInfo = getMembershipType(user)

  return (
    <Container>
      <Following
        onClick={setIsFollowsVisible}
        following={(user && user.numFollowing) || 0}
        followers={(user && user.numFollowers) || 0}
      />
      <Info title="Posts" value={Math.abs((user && user.numDesigns) || 0)} />
      {!isOthers && (
        <Info title="My Rooms" value={(user && user.numMyDecor) || 0} />
      )}
      <Info
        title="Challenges Joined"
        value={(user && user.numContestEntries) || 0}
      />
      {isOthers && (
        <Info
          title="Challenges Featured"
          value={(user && user.numContestWins) || 0}
        />
      )}
      {(membershipInfo.isMember || isOthers) && (
        <Actionable
          title="Membership"
          img={membershipInfo.isMember ? MEMBER : NONE_MEMBER}
          alt="Membership Badge"
          actionTitle={
            isOthers
              ? undefined
              : user?.membership?.name || membershipInfo.isMember
              ? 'View'
              : 'Upgrade'
          }
          onClick={handleMembership}
        >
          {membershipInfo.membershipName}
        </Actionable>
      )}
      {!isOthers && !membershipInfo.isMember && (
        <Actionable title="Membership" transparent>
          <MembershipBanner variant="profile" />
        </Actionable>
      )}
      {!isOthers && (
        <Actionable
          title="Dcoins"
          icon={() => <img src={coinIconImg} alt="" />}
          actionTitle="Refill"
          onButtonClick={handleCoin}
          onContainerClick={openCoinsHistory}
        >
          {user && user.numCoins && formatMoney(user.numCoins, 0)}
        </Actionable>
      )}
      <Actionable title="Badges" transparent>
        <Badges
          badgesComplete={user && user.badgeRewards}
          badgesIncomplete={user && user.badgesNotStarted}
          onClick={() => {}}
        />
      </Actionable>
      {isFollowsVisible && (
        <FollowListModal
          userId={user.objectId}
          onClose={() => setIsFollowsVisible(false)}
        />
      )}
    </Container>
  )
}
